/**
 * Several drops out of the list at once (19/10/2026 — "Delete the drops
 * outside the window"): one bulk op, so the positions are read against the
 * same list — removing them one by one would shift every later position.
 * For Media Devoted | Created By Ciro Autiero
 */
export function withoutSlots<T>(slots: T[], indexes: number[]): T[] {
  if (indexes.length === 0) return slots;
  const drop = new Set(indexes);
  return slots.filter((_, i) => !drop.has(i));
}
